module.exports = __webpack_public_path__ + "img/booking.b238ef8f.svg";